import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";

import { ALERT_RULES_QUERY_KEY } from "./useAlertRules";

export function useDeleteAlertRule() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation<void, Error, string>({
    mutationFn: async (alert_rule_id) => {
      const { error } = await client.DELETE("/api/alerts/rules/{alert_rule_id}", {
        params: { path: { alert_rule_id } },
      });
      if (error !== undefined) {
        throw new Error("Failed to delete alert rule");
      }
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ALERT_RULES_QUERY_KEY });
    },
  });
}
